<template>
  <BaseDialog
    class="device-error-dialog"
    :is-visible="true"
    :notif="modalTitle"
    width="48%"
    @close-dialog="$emit('close-dialog', true)"
  >
    <template #body>
      <div class="wrapper">
        <img class="error-vector" src="@/assets/img/device_error_sample_image.svg" />
        <div class="guide-text" v-html="errorGuide"></div>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseDialog from '@/components/Base/Dialog';

export default {
  components: { BaseDialog },
  props: {
    mediaDevice: {
      type: String,
      required: true,
      validator(value) {
        return ['mic', 'camera'].includes(value);
      }
    }
  },
  computed: {
    ...mapGetters('devices', [
      'isCameraPermissionDenied',
      'isMicPermissionDenied',
      'isCameraNotFound',
      'isMicNotFound'
    ]),
    ...mapGetters('uaParser', ['browserName', 'isMacOS', 'isChromeBrowser']),
    ...mapGetters(['isStudent']),

    mediaDeviceJaEn() {
      return this.isStudent ? this.$t(`deviceErrorGuide.${this.mediaDevice}`) : this.mediaDevice;
    },

    modalTitle() {
      return this.$t(`deviceErrorGuide.title.${this.errorType}`, { device: this.mediaDeviceJaEn });
    },

    errorGuide() {
      if (this.errorType === 'notFound') {
        const macOS = this.isMacOS ? 'MacOS' : '';
        return this.$t(`deviceErrorGuide.${this.errorType}${macOS}`, { device: this.mediaDeviceJaEn });
      }

      const macOSChrome = this.isMacOS && this.isChromeBrowser ? 'MacOS' : '';
      return this.$t(`deviceErrorGuide.${this.errorType}.${this.browserName}${macOSChrome}`, {
        device: this.mediaDeviceJaEn
      });
    },

    errorType() {
      if (this.mediaDevice === 'mic') {
        return this.isMicPermissionDenied ? 'permissionDenied' : 'notFound';
      }
      return this.isCameraPermissionDenied ? 'permissionDenied' : 'notFound';
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.device-error-dialog ::v-deep {
  .base-dialog {
    @media screen and (max-width: 498px) {
      margin-top: 60px !important;
    }
  }
  .body-scrollbar {
    max-height: 674px !important;
  }
  .notif {
    margin-bottom: 24px !important;
  }
  .wrapper {
    display: flex;
    column-gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 12px;
    .error-vector {
      width: 42%;
      @media screen and (max-width: 498px) {
        flex-basis: 54%;
      }
    }
    .guide-text {
      margin-top: 24px;
      flex-basis: 52%;
      @media screen and (max-width: 498px) {
        flex-basis: 100%;
      }
    }
  }
  ol li {
    list-style: decimal;
  }
  ul li {
    list-style: disc;
  }
  li {
    list-style-position: outside;
    margin-left: 1em;
    margin-bottom: 0.8em;
    word-break: normal;
  }
}
</style>
